import { render, staticRenderFns } from "./RemindersExtend.vue?vue&type=template&id=47604662&"
import script from "./RemindersExtend.vue?vue&type=script&lang=js&"
export * from "./RemindersExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports